@let pageData = pageData$ | async;
@let layoutContext = layoutContext$ | async;
@let isOverlayContext = layoutContext === 'overlay';
<div
  class="bd-frame-container"
  [ngClass]="{
    'bd-white-border': pageData,
    'bd-blue-border': isOverlayContext,
  }"
>
  @if (pageData) {
    @if (pageData.archived) {
      <div class="flex flex-col justify-center h-screen">
        <bd-call-to-action
          [title]="{ textKey: 'goToArchiveCTA.title', tScope: 'uiComponents' }"
          [subtitle]="{
            textKey: 'goToArchiveCTA.subtitle',
            tScope: 'uiComponents',
          }"
          [icon]="'ui-warning'"
          [actionButton]="{
            labelKey: 'goToArchiveCTA.buttonLabel',
            tScope: 'uiComponents',
            onClick: goToArchiveCTA,
          }"
        >
        </bd-call-to-action>
      </div>
    } @else {
      @if (pageData.toolContainerInputs.data) {
        <ng-template
          *ngComponentOutlet="
            pageData.toolContainerType;
            inputs: pageData.toolContainerInputs
          "
        />
      }
      @if (
        !pageData.toolContainerInputs.data ||
        !pageData.isFrame ||
        pageData.toolContainerInputs.data.sourceId !== pageData.frameId
      ) {
        <bd-backdrop data-id="frame-container-backdrop"></bd-backdrop>
      }
      @if (changeNameDialogProperties$ | async; as dialogProperties) {
        <bd-dialog
          #changeNameDialog
          [visible]="(changeNameDialogVisible$ | async) ?? false"
          (visibleChange)="
            onChangeNameDialogVisibleChange($event, pageData.frameId)
          "
          [dialogProperties]="dialogProperties"
          (confirm)="onChangeNameConfirm(pageData)"
          data-id="change-name-dialog"
        >
          <ng-container *transloco="let t; scope: 'uiComponents'">
            <input
              data-id="modal-input"
              class="w-full"
              type="text"
              maxlength="100"
              aria-label="Change name input"
              pInputText
              [pAutoFocus]="true"
              [ngModel]="changeNameValue()"
              (ngModelChange)="changeNameValue.set($event)"
              (keydown.enter)="changeNameDialog.onConfirm()"
            />
            <bd-helper-text
              class="mt-1"
              [text]="
                (changeNameValue()?.length ?? 0) >= 100
                  ? t('uiComponents.modal.characterLimitReached')
                  : ''
              "
              [showIcon]="true"
              state="warning"
            ></bd-helper-text>
          </ng-container>
        </bd-dialog>
      }
      @if (deleteFrameDialogProperties$ | async; as dialogProperties) {
        <bd-dialog
          [visible]="(deleteFrameDialogVisible$ | async) ?? false"
          (visibleChange)="onDeleteFrameVisibleChange($event)"
          [dialogProperties]="dialogProperties"
          (confirm)="onDeleteFrameConfirm(pageData.frameId, pageData.workspace)"
        >
          <div
            *transloco="let t; scope: 'featureWorkspaces'"
            class="bd-delete-frame-dialog-content"
          >
            <i class="ui-warning bd-failure"></i>
            <p class="bd-headline-small mt-6 mb-3">
              {{ t('featureWorkspaces.deleteFrameModal.title') }}
            </p>
            <span
              class="bd-body-large bd-ellipsis-text text-center"
              [innerHTML]="
                t('featureWorkspaces.deleteFrameModal.description', {
                  frameName: pageData.frameName,
                }) | highlight: pageData.frameName
              "
            ></span>
          </div>
        </bd-dialog>
      }
      <ng-container *transloco="let tWS; scope: 'featureWorkspaces'">
        <bd-content-open-container
          data-id="workspace-picker-dialog"
          [visible]="(workspacePickerDialogVisible$ | async) ?? false"
          (visibleChange)="workspacePickerDialogVisible$.next($event)"
          (selectionConfirm)="
            onWorkspacePickerSelectionConfirm($event, pageData)
          "
          [showOnlyWorkspaceStep]="true"
          [dialogTitle]="tWS('featureWorkspaces.workspace.addViewToFrameTitle')"
        />
      </ng-container>
      @let elementCollection =
        (elementCollection$ | async) ?? {
          objects: [],
          relations: [],
        };
      <bd-content-open-container
        [visible]="(contentOpenDialogVisible$ | async) ?? false"
        (visibleChange)="contentOpenDialogVisible$.next($event)"
        (selectionConfirm)="onContentOpenSelectionConfirm($event)"
        [elementCollection]="elementCollection"
        [elementCollectionLoading]="
          (elementCollectionLoadingSubject$ | async) ?? false
        "
        [numberOfCollectionElements]="elementCollection.objects.length"
        [selectedWorkspace]="pageData.workspace"
      ></bd-content-open-container>

      @if (inviteDialogProperties$ | async; as dialogProperties) {
        <bd-dialog
          [visible]="(inviteDialogVisible$ | async) ?? false"
          (visibleChange)="onInviteDialogVisibleChange($event)"
          [dialogProperties]="dialogProperties"
        >
          @if (workspaceItem$ | async; as workspace) {
            <bd-workspace-invite-container
              [workspace]="workspace"
              [visible]="(inviteDialogVisible$ | async) ?? false"
              [inlineNotificationVisible]="inlineNotificationVisible()"
              (inlineNotificationClose)="onInviteLinkClose()"
              (workspaceUpdate)="onWorkspaceUpdate($event)"
            />
          }
          @if (inviteDialogButton$ | async) {
            <div
              *transloco="let t; scope: 'featureWorkspaces'"
              class="flex justify-start mr-auto"
              footer
            >
              <p-button
                data-id="copy-frame-button"
                icon="pi pi-link"
                [link]="true"
                [label]="t('featureWorkspaces.inviteModal.copyButtonText')"
                (onClick)="onInviteCopyLink()"
              ></p-button>
            </div>
          }
        </bd-dialog>
      }
    }
  } @else if (isOverlayContext) {
    <div
      class="h-full w-full flex justify-center align-center flex-col gap-[50px] bd-loader-container bg-white"
    >
      <bd-loader
        [styleClass]="'!relative'"
        data-id="frame-container-loader"
      ></bd-loader>
      <bd-call-to-action
        tScope="featureAiAssistant"
        titleKey="loadingScreen.title"
        subtitleKey="loadingScreen.description"
      ></bd-call-to-action>
    </div>
  } @else {
    <bd-loader data-id="frame-container-loader"></bd-loader>
  }
</div>
